import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import authService from './api-authorization/AuthorizeService';
import { useIntl } from 'react-intl';
import {
    ProSidebar,
    Menu,
    MenuItem,
    SubMenu,
    SidebarHeader,
    SidebarFooter,
    SidebarContent,
} from 'react-pro-sidebar';
import { FaTachometerAlt, FaGem, FaList, FaGithub, FaRegLaughWink, FaHeart } from 'react-icons/fa';
import sidebarBg from '../assets/bg3.jpg';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PersonIcon from '@mui/icons-material/Person';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import HouseboatIcon from '@mui/icons-material/Houseboat';
import DatasetIcon from '@mui/icons-material/Dataset';
import CommentBankIcon from '@mui/icons-material/CommentBank';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import SellIcon from '@mui/icons-material/Sell';
import SummarizeIcon from '@mui/icons-material/Summarize';
import FlagIcon from '@mui/icons-material/Flag';
import AppsIcon from '@mui/icons-material/Apps';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

const Bullet = () => {
    return (<span style={{ fontSize: '24px' }}>&#x25E6;</span>)
}
const Aside = ({ image, collapsed, rtl, toggled, handleToggleSidebar }) => {
    const intl = useIntl();
    const [role, setRole] = useState('');

    useEffect(() => {

        async function getRole() {
            const token = await authService.getAccessToken();

            const response = await fetch('api/Usuarios/GetRole', {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const result = await response.text();
            setRole(result);
        }
        getRole();
    }, []);

    return (
        <ProSidebar
            image={image ? sidebarBg : false}
            rtl={rtl}
            collapsed={collapsed}
            toggled={toggled}
            breakPoint="md"
            onToggle={handleToggleSidebar}
        >
            <SidebarHeader>
                <div
                    style={{
                        paddingInline: '24px',
                        paddingBlock: '18px',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        fontSize: 14,
                        letterSpacing: '1px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <Link to="/">{intl.formatMessage({ id: 'sidebarTitle' })}</Link>

                </div>
            </SidebarHeader>

            <SidebarContent>
                {role == "Admin" ?
                    <Menu iconShape="circle">
                        <SubMenu title={intl.formatMessage({ id: 'Administrar' })} >
                            <MenuItem icon={<PersonIcon />}> <Link to="/Proveedores">{intl.formatMessage({ id: 'Proveedores' })} </Link></MenuItem>
                            <MenuItem icon={<DirectionsBoatIcon />}> <Link to="/Navieras">{intl.formatMessage({ id: 'Navieras' })}</Link></MenuItem>
                            <MenuItem icon={<HouseboatIcon />}> <Link to="/Destinos">{intl.formatMessage({ id: 'Destinos' })}</Link></MenuItem>
                            <MenuItem icon={<FlagIcon />}> <Link to="/Paises">{intl.formatMessage({ id: 'Paises' })}</Link></MenuItem>
                            <SubMenu icon={<DatasetIcon />} title={intl.formatMessage({ id: 'Generales' })} >
                                <MenuItem icon={<Bullet />}> <Link to="/Productos">{intl.formatMessage({ id: 'Productos' })}</Link></MenuItem>
                                <MenuItem icon={<Bullet />}> <Link to="/TiposFruta">{intl.formatMessage({ id: 'TiposFruta' })}</Link></MenuItem>
                                <MenuItem icon={<Bullet />}> <Link to="/CajasPorPaleta">{intl.formatMessage({ id: 'CajasPorPaleta' })}</Link></MenuItem>
                            </SubMenu>
                            <SubMenu icon={<CommentBankIcon />} title={intl.formatMessage({ id: 'Etiquetas Core' })} >
                                <MenuItem icon={<Bullet />}> <Link to="/Cartones">{intl.formatMessage({ id: 'Cartones' })}</Link></MenuItem>
                                <MenuItem icon={<Bullet />}> <Link to="/Colillas">{intl.formatMessage({ id: 'Colillas' })}</Link></MenuItem>
                                <MenuItem icon={<Bullet />}> <Link to="/EtiquetasCore">{intl.formatMessage({ id: 'EtiquetasCore' })}</Link></MenuItem>
                            </SubMenu>
                            {/*<MenuItem icon={<MonitorWeightIcon />}> <Link to="/Variantes">{intl.formatMessage({ id: 'Variantes' })}</Link></MenuItem>*/}
                            <MenuItem icon={<LocalShippingIcon />}> <Link to="/Contenedores">{intl.formatMessage({ id: 'Contenedores' })}</Link></MenuItem>
                        </SubMenu>
                        <SubMenu title={intl.formatMessage({ id: 'FlujoDeTrabajo' })} >
                            <MenuItem icon={<EventAvailableIcon />}> <Link to="/SemanasAdmin">{intl.formatMessage({ id: 'Semanas de trabajo' })}</Link></MenuItem>
                            <MenuItem icon={<EventAvailableIcon />}> <Link to="/PBI_Analisis">{intl.formatMessage({ id: 'PBI Analisis' })}</Link></MenuItem>
                            <MenuItem icon={<SmartToyOutlinedIcon />}> <Link to="/AsistenteOrsero">{intl.formatMessage({ id: 'AsistenteOrsero' })}</Link></MenuItem>
                        </SubMenu>
                    </Menu> :
                    role == "Proveedor" ?
                        <Menu iconShape="circle">
                            <SubMenu title={intl.formatMessage({ id: 'FlujoDeTrabajo' })} >
                                <MenuItem icon={<EventAvailableIcon />}> <Link to="/Semanas">{intl.formatMessage({ id: 'Semanas de trabajo' })}</Link></MenuItem>
                                <MenuItem icon={<SummarizeIcon />}> <Link to="/ReporteDespacho">{intl.formatMessage({ id: 'Reportes' })}</Link></MenuItem>
                                <MenuItem icon={<SellIcon />}> <Link to="/EtiquetasCoreProveedor">{intl.formatMessage({ id: 'EtiquetasCore' })}</Link></MenuItem>
                                <MenuItem icon={<AppsIcon />}> <Link to="/VariantesProveedor">{intl.formatMessage({ id: 'Variantes' })}</Link></MenuItem>
                                {/*<MenuItem icon={<HelpCenterOutlinedIcon />}> <Link to="/ValoresReferencia">{intl.formatMessage({ id: 'Valores de referencia' })}</Link></MenuItem>*/}
                            </SubMenu>
                        </Menu> :
                        <Menu iconShape="circle"></Menu>
                }

                {/*<Menu iconShape="circle">*/}
                {/*    <SubMenu  title={intl.formatMessage({ id: 'Menu Proveedor' })} >*/}
                {/*        <MenuItem icon={<EventAvailableIcon />}> <Link to="/Semanas">{intl.formatMessage({ id: 'Semanas de trabajo' })}</Link></MenuItem>*/}
                {/*    </SubMenu>*/}
                {/*</Menu>*/}


            </SidebarContent>

            <SidebarFooter style={{ textAlign: 'center' }}>
                <div
                    className="sidebar-btn-wrapper"
                    style={{
                        padding: '20px 24px',
                    }}
                >
                    <a
                        href="javascript:;"
                        target="_self"
                        className="sidebar-btn"
                        rel="noopener noreferrer"
                    >
                        <span style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                            SeedingCore {new Date().getFullYear()}
                        </span>
                    </a>
                </div>
            </SidebarFooter>
        </ProSidebar>
    );
};

export default Aside;
